const BHMosaicGallery = {
	BHMosaicGallery: {
		defaultProps: {
			imageSize: 50,
		},
	},
}

export default BHMosaicGallery
